import EmbedPolicy from 'embed/components/embed_policy';

export default class VideoBlocker extends EmbedPolicy {
  init() {
    this.getReferrerDomain();
    this.getAllowedDomains();
    this.isAllowed();
    this.showVideoBlocker();
  }

  element() {
    return this.$element;
  }

  getAllowedDomains() {
    this.allowedDomains = this.element().data('allowed-domains');
  }

  showVideoBlocker() {
    if(this.isElementExist() && !this.siteAllowed){
      this.showBlocker();
    }
  }

  isElementExist() {
    return this.element().length != 0;
  }

  showBlocker() {
    this.showElement();
    this.disablePlayer();
  }
  
  showElement() {
    this.element().removeClass('hide');
  }

  disablePlayer() {
    this._disposeIntervalId = setInterval(this.disposePlayer.bind(this), 100);
  }

  disposePlayer() {
    if(window.player && window.player.tech() && window.player.tech().plugin()) {
      window.player.tech().dispose();
      clearInterval(this._disposeIntervalId);
      this._disposeIntervalId = null;
    } else if(this._disposeCounter == 100) {
      clearInterval(this._disposeIntervalId);
      this._disposeIntervalId = null;
    }
    this._disposeCounter++;
  }
}